module.exports = __webpack_public_path__ + "img/type_create-our-los-angeles.0a0911c5.svg";